import createReducer from "../createReducer";
import { IFieldsState } from "./types";
import { handlersFields } from "./handlers";

export const FieldsInitialState: IFieldsState = {
    list: [],
    isLoading: false,
    isHavePromoCodeField: false,
    isHavePaymentTypeField: false,
};

export default createReducer(FieldsInitialState, handlersFields);
